<template>
  <header-layout>
    <section id="password-reset-email">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <form class="form" v-if="!isSent">
              <h1 class="title">Reset your password</h1>
              <p class="content">Please enter your email, we will send you a link there to finish the process.</p>

              <div v-if="errorMessage" class="notification is-danger has-text-center">
                {{ errorMessage }}
              </div>

              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  <input class="input" type="email" placeholder="alice@example.com" v-model="email">
                </div>
              </div>
              <div class="columns">
                <div class="column is-half is-offset-one-quarter">
                  <button class="button is-fullwidth" :class="{ 'is-loading': isSending }" type="submit" @click.prevent="send()">Send</button>
                </div>
              </div>
            </form>

            <div class="card has-border-dark has-text-centered" v-if="isSent">
              <div class="card-content">
                <p>We just sent an email to your inbox, please click the button in there to change your password.</p>
                <br>
                <p><em><small>Tip: If you can't see the email, check your spam folder, just in case</small></em></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </header-layout>
</template>

<script>
import HeaderLayout from '@/layouts/HeaderLayout'

export default {
  components: {
    HeaderLayout
  },

  methods: {
    send () {
      if (!this.isSending && this.email !== '') {
        this.isSending = true
        this.$store.dispatch('sendResetPasswordEmail', { email: this.email })
          .then(sent => {
            if (sent) {
              this.isSent = true
            }
          })
          .finally(() => {
            this.isSending = false
          })
      }
    }
  },

  data () {
    return {
      email: '',
      isSending: false,
      isSent: false,
      errorMessage: null
    }
  }
}
</script>

<style lang="scss">

#password-reset-email {
  margin: 6rem 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/PasswordResetEmailPage.vue